export default __webpack_public_path__ + "static/media/left_character.6a2dbc46.png";